import { Id, Identifiable, OrganizationalUnit } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function removeOrganizationalUnit(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<OrganizationalUnit>) =>
    httpClient
      .sendHttpRequest<{ organizationalUnitUuids: Id[]; resourceUuids: Id[] }>({
        endpoint: `/organizational-units/${uuid}/subtree`,
        method: HttpMethods.DELETE,
      })
      .then(({ organizationalUnitUuids, resourceUuids }) => ({
        organizationalUnitUuids,
        resourceUuids,
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { removeOrganizationalUnit };
